import { Alert } from 'roo-ui/components';

const NoAccessAlert = (props) => {
  return (
    <Alert icon={{ name: 'info', color: 'greys.steel' }} bg="white" {...props}>
      To protect your security relating to your booking information, we require you to cancel your booking via the cancellation link within
      the original booking confirmation email.
    </Alert>
  );
};

export default NoAccessAlert;
